import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { authOptions } from 'api/auth';
// Consume the client generated by the shared APIs library.
import { MFAService } from 'api/shared/mfa/v1/api.pb';
import { selectApp } from 'containers/App/selectors';

// Scope cached status to the signed-in user and tenant; refetch after account-console changes.
export function useMFAStatus(enabled = true) {
  const { organization, user } = useSelector(selectApp);
  return useQuery({
    queryKey: ['mfa-status', organization, user.info.id],
    queryFn: ({ signal }) =>
      MFAService.GetStatus({}, { ...authOptions(), signal }),
    enabled: enabled && !!organization && !!user.info.id,
    retry: false,
    staleTime: 0,
  });
}
